export const clientApi = '/api/v1/users/client/';
